import { z } from 'zod'

export const closingShiftSchema = z.object({
  id: z.coerce.number(),
  cash_difference: z.coerce.number().transform(val => parseFloat(val.toFixed(2))),
  closing_cash_amount: z.coerce.number().transform(val => parseFloat(val.toFixed(2))),
  closing_notes: z.string().nullable().optional().default(null),
  end_timestamp: z.string(),
  expected_cash_amount: z.coerce.number().transform(val => parseFloat(val.toFixed(2))),
  status: z.enum(['open', 'closed', 'in_progress']),
})

export type ClosingShift = z.infer<typeof closingShiftSchema>
